module.exports = __webpack_public_path__ + "img/solad.b078a39c.webp";